define('rebrush/components/cartware/slider',[
	'cartware/components/_base',
	'cartware/jquery/bem',
	'cartware/utils/image/preload',
	'jquery',
	'lodash',
	'json!shoptheme/etc/breakpoints.json',
	'enquire',
	'cartware-slider'
], function(
	Component,
	BEM,
	preload,
	$,
	_,
	BreakPoints,
	enquire
) {
	var TEASER_MODE_COMBINED	= 'combined',
		TEASER_MODE_STACKED		= 'stacked';

	var BACKGROUND_MODE_STRETCH 	= 'stretch',
		BACKGROUND_MODE_INFLATE 	= 'inflate';

	return Component.create({
		teaserLayoutCallbacks:			null,
		teaserMode:						null,

		backgroundLayoutCallbacks:		null,
		backgroundMode:					null,

		slideshows:						null,

		constructor: function() {
			this.teaserLayoutCallbacks = [];
			this.teaserMode = TEASER_MODE_STACKED;

			this.backgroundLayoutCallbacks = [];
			this.backgroundMode = BACKGROUND_MODE_INFLATE;

			this.slideshows = [];
		},

		init: function() {
			enquire.register('(min-width: ' + (BreakPoints.xs + 1) + 'px)', {
				match: _.bind(this.layoutTeasersCombined, this),
				unmatch: _.bind(this.layoutTeasersStacked, this)
			}, true);

			enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
				match: _.bind(this.layoutBackgroundStretch, this),
				unmatch: _.bind(this.layoutBackgroundInflate, this)
			}, true);
		},

		$init: function() {
			var self = this;

			var reflow = _.throttle(function() {
				_.forEach(self.slideshows, function(slideshow) {
					slideshow.reflow();
				});
			}, 150);

			BEM.block('cartware-slider-slide:modifier(teaser)').each(function() {
				var slide = BEM.block(this),
					wrapper = slide.getElements('wrapper'),
					teaser = slide.getElements('teaser'),
					vAlignMiddle = wrapper.is(':modifier(v-middle)'),
					slider = slide.parents('.cartware-slider:first'),
					slideshow = slider.data('cartware_slider/instance');
					// adjustMargin = slider.parents('.container').length === 0;

				if (self.slideshows.indexOf(slideshow) < 0) {
					self.slideshows.push(slideshow);
				}

				var layout = function() {
					// var viewportWidth = slider.width(),
					// 	slideTextContentMargin;
					//
					// if (adjustMargin) {
					// 	slideTextContentMargin = Math.round((viewportWidth - wrapper.outerWidth()) / 2);
					//
					// 	wrapper.css({
					// 		marginLeft: slideTextContentMargin,
					// 		marginRight: slideTextContentMargin
					// 	});
					// }

					if (vAlignMiddle && self.teaserMode === TEASER_MODE_COMBINED) {
						wrapper.css({
							top: Math.round((slide.innerHeight() - teaser.outerHeight()) / 2)
						});
					}

					// teaser.css({
					// 	width: self.teaserMode === TEASER_MODE_STACKED ? viewportWidth : ''
					// });

					slide.css({
						minHeight: self.teaserMode === TEASER_MODE_STACKED ? '' : wrapper.outerHeight() + wrapper.position().top
					});

					reflow();
				};

				$(window).resize(_.throttle(layout, 150));
				layout();

				self.teaserLayoutCallbacks.push(layout);
			});

			$('.cartware-slider-slide-background').each(function() {
				var backgroundContainer = $(this),
					backgroundImage = backgroundContainer.css('background-image').match(/^url\(["'](.*)["']\)$/)[1] || null,
					slide = backgroundContainer.closest('.cartware-slider-item-wrap'),
					slider = slide.closest('.cartware-slider'),
					slideshow = slider.data('cartware_slider/instance'),
					stage = slide.closest('.cartware-slider-stage'),
					inner = slide.find('.teaser-inner:first'),
					imageDimensions = null;

				if (!backgroundImage) {
					return;
				}

				if (self.slideshows.indexOf(slideshow) < 0) {
					self.slideshows.push(slideshow);
				}

				var layout = function() {
					backgroundContainer.css(
						'min-height',
						self.backgroundMode === BACKGROUND_MODE_STRETCH ? imageDimensions.height : ''
					);

					slide.css(
						'min-height',
						self.backgroundMode === BACKGROUND_MODE_STRETCH ? imageDimensions.height : ''
					);

					inner.css('min-height', '');

					slideshow.reflow();
				};

				slideshow.on('reflow', function() {
					inner.css(
						'min-height',
						self.backgroundMode === BACKGROUND_MODE_STRETCH ? '' : stage.height()
					);
				});
                
				preload(backgroundImage, function(err, info) {
					if (err) {
						throw err;
					} else {
						imageDimensions = info;

						$(window).resize(_.throttle(layout, 150));
						layout();

						self.backgroundLayoutCallbacks.push(layout);
					}
				});

				//var img = imagePool.alloc();
				//
				//img.onload = function() {
				//	imageDimensions = {
				//		width: img.width,
				//		height: img.height
				//	};
				//
				//	$(window).resize(_.throttle(layout, 150));
				//	layout();
				//
				//	self.backgroundLayoutCallbacks.push(layout);
				//
				//	imagePool.release(img);
				//};
				//
				//img.onerror = function() {
				//	imagePool.release(img);
				//};
				//
				//img.src = backgroundImage;
			});
		},

		layoutTeasers: function() {
			_.forEach(this.teaserLayoutCallbacks, function(cb) {
				cb();
			});
		},

		layoutTeasersCombined: function() {
			this.teaserMode = TEASER_MODE_COMBINED;
			this.layoutTeasers();
		},

		layoutTeasersStacked: function() {
			this.teaserMode = TEASER_MODE_STACKED;
			this.layoutTeasers();
		},

		layoutBackgrounds: function() {
			_.forEach(this.backgroundLayoutCallbacks, function(cb) {
				cb();
			});
		},

		layoutBackgroundStretch: function() {
			this.backgroundMode = BACKGROUND_MODE_STRETCH;
			this.layoutBackgrounds();
		},

		layoutBackgroundInflate: function() {
			this.backgroundMode = BACKGROUND_MODE_INFLATE;
			this.layoutBackgrounds();
		}
	});
});
